import { useLocale } from '@ecomm/data-hooks'
import {
  monthlyToLocalizedDailyPrice,
  usePriceContext
} from '@ecomm/data-price/'
import * as O from 'fp-ts/lib/Option'

export type PriceDisplayProps = {
  /** The SKU for which the price is displayed */
  sku: string
}

export function PriceDisplay({ sku }: PriceDisplayProps) {
  const { getPrice } = usePriceContext()
  const locale = useLocale()
  const priceText = O.match(
    () => null,
    (price: number) => {
      return monthlyToLocalizedDailyPrice(
        locale,
        price,
        sku === 'SSEDSM2__4867366' ? 'ceil' : 'floor'
      )
    }
  )(getPrice(sku))

  return (
    <p className="text-sm font-bold mt-3 md:text-2xl">
      {priceText}/
      <br className="block md:hidden" />
      day
    </p>
  )
}
